import React from 'react';
import Block from '../../Block';
import { Date } from '../../Format';
import useCustomTable from '../../tables/useCustomTable';
import Table from '../../tables/Table';

export const processHistory = (accessor) => (data) => (
  data ? Object.entries(data).reduce(
    (a,v) => ([...a, { date: v[0], [accessor]: v[1] }]), []
  ) : []
)

const HistoryBlock = ({title, data, cloumnTitle, cloumnAccessor})=>{
  const columns = [{
    Header: 'Date',
    accessor: 'date',
    Cell: ({row}) => (<Date dateFormat = 'long' date={row.original.date}/>),
  },{
    Header: cloumnTitle,
    accessor: cloumnAccessor,
    Cell: ({row}) => (JSON.stringify(row.original[cloumnAccessor])),
  }]

  const {
    tableProps
  } = useCustomTable({
    sortable: true,
    paginate: false,
    filterable: false,
  })
  return (
    <Block title={title}>
      <Table data={data} columns={columns} {...tableProps} />
    </Block>
  )
}

export default HistoryBlock
